import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    InputRightElement,
    VStack,
    Heading,
    Text,
    useToast,
    Flex,
    Icon,
    PinInput,
    PinInputField,
    HStack,
    Divider,
    useColorModeValue,
    Spinner,
    Select,
    InputLeftElement,
} from '@chakra-ui/react';
import { FaEye, FaEyeSlash, FaArrowLeft, FaHome, FaCheck, FaTimes } from 'react-icons/fa';
import { TiPiOutline } from "react-icons/ti";
import { Link, useNavigate } from 'react-router-dom';

// Country codes data
const COUNTRIES = [
    { code: '+1', name: 'United States', flag: '🇺🇸', length: 10 },
    { code: '+1', name: 'Canada', flag: '🇨🇦', length: 10 },
    { code: '+44', name: 'United Kingdom', flag: '🇬🇧', length: 10 },
    { code: '+91', name: 'India', flag: '🇮🇳', length: 10 },
    { code: '+61', name: 'Australia', flag: '🇦🇺', length: 9 },
    { code: '+81', name: 'Japan', flag: '🇯🇵', length: 10 },
    { code: '+86', name: 'China', flag: '🇨🇳', length: 11 },
    { code: '+49', name: 'Germany', flag: '🇩🇪', length: 10 },
    { code: '+33', name: 'France', flag: '🇫🇷', length: 9 },
    { code: '+39', name: 'Italy', flag: '🇮🇹', length: 10 },
    { code: '+34', name: 'Spain', flag: '🇪🇸', length: 9 },
    { code: '+7', name: 'Russia', flag: '🇷🇺', length: 10 },
    { code: '+55', name: 'Brazil', flag: '🇧🇷', length: 11 },
    { code: '+52', name: 'Mexico', flag: '🇲🇽', length: 10 },
    { code: '+27', name: 'South Africa', flag: '🇿🇦', length: 9 },
    { code: '+20', name: 'Egypt', flag: '🇪🇬', length: 10 },
    { code: '+234', name: 'Nigeria', flag: '🇳🇬', length: 10 },
    { code: '+254', name: 'Kenya', flag: '🇰🇪', length: 9 },
    { code: '+971', name: 'UAE', flag: '🇦🇪', length: 9 },
    { code: '+966', name: 'Saudi Arabia', flag: '🇸🇦', length: 9 },
    { code: '+65', name: 'Singapore', flag: '🇸🇬', length: 8 },
    { code: '+60', name: 'Malaysia', flag: '🇲🇾', length: 9 },
    { code: '+62', name: 'Indonesia', flag: '🇮🇩', length: 10 },
    { code: '+63', name: 'Philippines', flag: '🇵🇭', length: 10 },
    { code: '+66', name: 'Thailand', flag: '🇹🇭', length: 9 },
    { code: '+84', name: 'Vietnam', flag: '🇻🇳', length: 9 },
    { code: '+82', name: 'South Korea', flag: '🇰🇷', length: 10 },
    { code: '+92', name: 'Pakistan', flag: '🇵🇰', length: 10 },
    { code: '+880', name: 'Bangladesh', flag: '🇧🇩', length: 10 },
    { code: '+94', name: 'Sri Lanka', flag: '🇱🇰', length: 9 },
    { code: '+977', name: 'Nepal', flag: '🇳🇵', length: 10 },
    { code: '+64', name: 'New Zealand', flag: '🇳🇿', length: 9 },
    { code: '+351', name: 'Portugal', flag: '🇵🇹', length: 9 },
    { code: '+31', name: 'Netherlands', flag: '🇳🇱', length: 9 },
    { code: '+32', name: 'Belgium', flag: '🇧🇪', length: 9 },
    { code: '+41', name: 'Switzerland', flag: '🇨🇭', length: 9 },
    { code: '+43', name: 'Austria', flag: '🇦🇹', length: 10 },
    { code: '+45', name: 'Denmark', flag: '🇩🇰', length: 8 },
    { code: '+46', name: 'Sweden', flag: '🇸🇪', length: 9 },
    { code: '+47', name: 'Norway', flag: '🇳🇴', length: 8 },
    { code: '+358', name: 'Finland', flag: '🇫🇮', length: 9 },
    { code: '+48', name: 'Poland', flag: '🇵🇱', length: 9 },
    { code: '+420', name: 'Czech Republic', flag: '🇨🇿', length: 9 },
    { code: '+36', name: 'Hungary', flag: '🇭🇺', length: 9 },
    { code: '+30', name: 'Greece', flag: '🇬🇷', length: 10 },
    { code: '+90', name: 'Turkey', flag: '🇹🇷', length: 10 },
    { code: '+98', name: 'Iran', flag: '🇮🇷', length: 10 },
    { code: '+972', name: 'Israel', flag: '🇮🇱', length: 9 },
    { code: '+56', name: 'Chile', flag: '🇨🇱', length: 9 },
    { code: '+54', name: 'Argentina', flag: '🇦🇷', length: 10 },
    { code: '+57', name: 'Colombia', flag: '🇨🇴', length: 10 },
    { code: '+51', name: 'Peru', flag: '🇵🇪', length: 9 },
    { code: '+58', name: 'Venezuela', flag: '🇻🇪', length: 10 },
];

function RegisterForm() {
    const API_BASE_URL = process.env.NODE_ENV === "development" ? process.env.REACT_APP_API_BASE_URL_DEV : process.env.REACT_APP_API_BASE_URL_PROD;
    const [showPassword, setShowPassword] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [formData, setFormData] = useState({
        restaurantName: '',
        email: '',
        phoneNumber: '',
        password: ''
    });
    const [selectedCountry, setSelectedCountry] = useState(COUNTRIES.find(c => c.code === '+91')); // Default to India
    const [otp, setOtp] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({ text: '', isSuccess: false, showSuccess: false });
    const toast = useToast();
    const navigate = useNavigate();

    const bgColor = useColorModeValue('#fafaf7', 'gray.800');
    const accentColor = useColorModeValue('yellow.400', 'yellow.500');

    const [subdomain, setSubdomain] = useState('');
    const [isSubdomainAvailable, setIsSubdomainAvailable] = useState(null);
    const [isCheckingSubdomain, setIsCheckingSubdomain] = useState(false);
    const [subdomainMessage, setSubdomainMessage] = useState('');

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (subdomain.trim() && subdomain.length >= 3) {
                checkSubdomainAvailabilityLive();
            } else if (subdomain.trim() && subdomain.length < 3) {
                setIsSubdomainAvailable(null);
                setSubdomainMessage('Subdomain must be at least 3 characters long');
            } else {
                setIsSubdomainAvailable(null);
                setSubdomainMessage('');
            }
        }, 500);

        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line
    }, [subdomain]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === 'phoneNumber') {
            // Remove all non-digits
            let formattedValue = value.replace(/\D/g, '');

            // Limit based on selected country's expected length
            const maxLength = selectedCountry?.length || 15;
            if (formattedValue.length > maxLength) {
                formattedValue = formattedValue.substring(0, maxLength);
            }

            setFormData(prev => ({
                ...prev,
                [name]: formattedValue
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const handleCountryChange = (e) => {
        const countryIndex = parseInt(e.target.value);
        setSelectedCountry(COUNTRIES[countryIndex]);
        // Clear phone number when country changes
        setFormData(prev => ({
            ...prev,
            phoneNumber: ''
        }));
    };

    const validateForm = () => {
        if (!subdomain.trim()) {
            setMessage({ text: 'Subdomain is required', isSuccess: false, showSuccess: false });
            return false;
        }

        if (subdomain.length < 3) {
            setMessage({ text: 'Subdomain must be at least 3 characters long', isSuccess: false, showSuccess: false });
            return false;
        }

        if (isSubdomainAvailable === false) {
            setMessage({ text: 'Please choose an available subdomain', isSuccess: false, showSuccess: false });
            return false;
        }

        if (isSubdomainAvailable === null) {
            setMessage({ text: 'Please wait for subdomain availability check to complete', isSuccess: false, showSuccess: false });
            return false;
        }

        const { restaurantName, email, phoneNumber, password } = formData;

        if (!restaurantName.trim()) {
            setMessage({ text: 'Restaurant name is required', isSuccess: false, showSuccess: false });
            return false;
        }

        if (!email.trim()) {
            setMessage({ text: 'Email address is required', isSuccess: false, showSuccess: false });
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setMessage({ text: 'Please enter a valid email address', isSuccess: false, showSuccess: false });
            return false;
        }

        if (!phoneNumber.trim()) {
            setMessage({ text: 'Phone number is required', isSuccess: false, showSuccess: false });
            return false;
        }

        // Validate phone number based on selected country
        if (!selectedCountry) {
            setMessage({ text: 'Please select a country', isSuccess: false, showSuccess: false });
            return false;
        }

        // Check if phone number has the expected length for the selected country
        const expectedLength = selectedCountry.length;
        if (phoneNumber.length < expectedLength - 2 || phoneNumber.length > expectedLength + 2) {
            setMessage({
                text: `Please enter a valid phone number for ${selectedCountry.name} (typically ${expectedLength} digits)`,
                isSuccess: false,
                showSuccess: false
            });
            return false;
        }

        if (!password.trim()) {
            setMessage({ text: 'Password is required', isSuccess: false, showSuccess: false });
            return false;
        }

        if (password.length < 6) {
            setMessage({ text: 'Password must be at least 6 characters long', isSuccess: false, showSuccess: false });
            return false;
        }

        return true;
    };

    const checkSubdomainAvailabilityLive = async () => {
        const sanitized = sanitizeSubdomain(subdomain);

        if (!sanitized) {
            setIsSubdomainAvailable(null);
            setSubdomainMessage('Invalid subdomain format');
            return;
        }

        setIsCheckingSubdomain(true);
        setSubdomainMessage('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/landingAuth/check-subdomain-availability`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ subdomain: sanitized }),
            });

            const data = await response.json();

            if (response.ok) {
                setIsSubdomainAvailable(true);
                setSubdomainMessage('Subdomain is available!');
            } else {
                setIsSubdomainAvailable(false);
                setSubdomainMessage(data.message || 'Subdomain is not available');
            }
        } catch (error) {
            setIsSubdomainAvailable(null);
            setSubdomainMessage('Error checking subdomain availability');
        } finally {
            setIsCheckingSubdomain(false);
        }
    };

    const checkSubdomainAvailability = async () => {
        if (!subdomain.trim()) {
            setMessage({ text: 'Subdomain is required', isSuccess: false, showSuccess: false });
            return false;
        }

        if (subdomain.length < 3) {
            setMessage({ text: 'Subdomain must be at least 3 characters long', isSuccess: false, showSuccess: false });
            return false;
        }

        if (isSubdomainAvailable === true) {
            return true;
        }

        if (isSubdomainAvailable === false) {
            setMessage({ text: 'Please choose an available subdomain', isSuccess: false, showSuccess: false });
            return false;
        }

        if (isCheckingSubdomain) {
            setMessage({ text: 'Please wait for subdomain availability check to complete', isSuccess: false, showSuccess: false });
            return false;
        }

        return isSubdomainAvailable === true;
    };

    const handleSendOtp = async (e) => {
        e.preventDefault();
        setMessage({ text: '', isSuccess: false, showSuccess: false });

        const isAvailable = await checkSubdomainAvailability();
        if (!isAvailable) {
            return;
        }

        if (!validateForm()) {
            return;
        }

        setIsLoading(true);

        try {
            // Format phone number with country code
            const fullPhoneNumber = `${selectedCountry.code}${formData.phoneNumber}`;

            const response = await fetch(`${API_BASE_URL}/api/landingAuth/send-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                    phoneNumber: fullPhoneNumber
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setMessage({ text: data.message || 'Failed to send OTP', isSuccess: false, showSuccess: false });
                toast({
                    title: 'Error',
                    description: data.message || 'Failed to send OTP',
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                    position: 'top'
                });
            } else {
                setCurrentStep(2);
                toast({
                    title: 'OTP Sent',
                    description: 'Please check your email for the verification code' + (selectedCountry.code === '+91' ? ' and SMS' : ''),
                    status: 'success',
                    duration: 5000,
                    isClosable: true,
                    position: 'top'
                });
            }

        } catch (error) {
            setMessage({ text: 'Network error. Please try again.', isSuccess: false, showSuccess: false });
            toast({
                title: 'Network Error',
                description: 'Please check your connection and try again',
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'top'
            });
        } finally {
            setIsLoading(false);
        }
    };

    const sanitizeSubdomain = (name) => {
        return name
            .toLowerCase()
            .replace(/@/g, '-at-')
            .replace(/&/g, '-and-')
            .replace(/[^a-z0-9-]+/g, '-')
            .replace(/^-+|-+$/g, '')
            .substring(0, 63);
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage({ text: '', isSuccess: false, showSuccess: false });

        try {
            // Format phone number with country code
            const fullPhoneNumber = `${selectedCountry.code}${formData.phoneNumber}`;

            const response = await fetch(`${API_BASE_URL}/api/landingAuth/verify-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    restaurantName: formData.restaurantName,
                    email: formData.email,
                    phoneNumber: fullPhoneNumber,
                    password: formData.password,
                    subdomain: sanitizeSubdomain(subdomain),
                    otp
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setMessage({ text: data.message || 'Verification failed', isSuccess: false, showSuccess: false });
                toast({
                    title: 'Verification Error',
                    description: data.message || 'Verification failed',
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                    position: 'top'
                });
            } else {
                setMessage({
                    text: (
                        <div>
                            Registration successful! Your site will be available soon at{' '}
                            <a
                                href={`https://admin.${sanitizeSubdomain(subdomain)}.piepos.in`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#3182ce', textDecoration: 'underline' }}
                            >
                                admin.{sanitizeSubdomain(subdomain)}.piepos.in
                            </a>
                        </div>
                    ),
                    isSuccess: true,
                    showSuccess: true
                });
                toast({
                    title: 'Registration Successful',
                    description: 'Your account has been created successfully',
                    status: 'success',
                    duration: 5000,
                    isClosable: true,
                    position: 'top'
                });
            }

        } catch (error) {
            setMessage({ text: 'Network error. Please try again.', isSuccess: false, showSuccess: false });
            toast({
                title: 'Network Error',
                description: 'Please check your connection and try again',
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'top'
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleResendOtp = async () => {
        setIsLoading(true);
        setMessage({ text: '', isSuccess: false, showSuccess: false });

        try {
            // Format phone number with country code
            const fullPhoneNumber = `${selectedCountry.code}${formData.phoneNumber}`;

            const response = await fetch(`${API_BASE_URL}/api/landingAuth/send-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                    phoneNumber: fullPhoneNumber
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                toast({
                    title: 'Error',
                    description: data.message || 'Failed to resend OTP',
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                    position: 'top'
                });
            } else {
                toast({
                    title: 'OTP Resent',
                    description: 'A new verification code has been sent to your email' + (selectedCountry.code === '+91' ? ' and SMS' : ''),
                    status: 'success',
                    duration: 5000,
                    isClosable: true,
                    position: 'top'
                });
            }

        } catch (error) {
            toast({
                title: 'Network Error',
                description: 'Please check your connection and try again',
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'top'
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackToForm = () => {
        setCurrentStep(1);
        setOtp('');
        setMessage({ text: '', isSuccess: false, showSuccess: false });
    };

    const handleGoBackHome = () => {
        setFormData({
            restaurantName: '',
            email: '',
            phoneNumber: '',
            password: ''
        });
        setSubdomain('');
        setOtp('');
        setCurrentStep(1);
        setMessage({ text: '', isSuccess: false, showSuccess: false });
        // <Navigate to="/" />
        navigate('/');
    };

    const handleSubdomainChange = (e) => {
        const value = e.target.value;
        setSubdomain(value);

        if (value !== subdomain) {
            setIsSubdomainAvailable(null);
            setSubdomainMessage('');
        }
    };

    return (
        <Box
            position="relative"
            width="100vw"
            minHeight="100vh"
            bg={bgColor}
            overflow="hidden"
        >
            {/* Back to Home Button */}
            <Box
                position="absolute"
                top={{ base: 4, md: 6 }}
                left={{ base: 4, md: 6 }}
                zIndex="10"
            >
                <Button
                    as={Link}
                    to="/"
                    variant="ghost"
                    leftIcon={<FaArrowLeft />}
                    size={{ base: "sm", md: "md" }}
                    color="gray.700"
                    _hover={{ bg: 'blackAlpha.100', transform: 'translateX(-2px)' }}
                    transition="all 0.2s"
                    fontWeight="medium"
                >
                    Home
                </Button>
            </Box>
            {/* Decorative Elements - keeping your existing decorations */}
            <Box
                display={{ base: 'none', md: 'block' }}
                position="absolute"
                top="5%"
                left="3%"
                w="200px"
                h="200px"
                bg="yellow.400"
                borderRadius="50% 30% 70% 40%"
                opacity="0.6"
                zIndex="0"
                animation="float 6s ease-in-out infinite"
                sx={{
                    '@keyframes float': {
                        '0%, 100%': { transform: 'translateY(0px) rotate(0deg)' },
                        '50%': { transform: 'translateY(-20px) rotate(5deg)' }
                    }
                }}
            />

            <Box
                display={{ base: 'none', lg: 'block' }}
                position="absolute"
                top="15%"
                right="8%"
                w="150px"
                h="150px"
                bg="yellow.300"
                borderRadius="40% 60% 30% 70%"
                opacity="0.5"
                zIndex="0"
                animation="float 8s ease-in-out infinite reverse"
                sx={{
                    '@keyframes float': {
                        '0%, 100%': { transform: 'translateY(0px) rotate(0deg)' },
                        '50%': { transform: 'translateY(-15px) rotate(-3deg)' }
                    }
                }}
            />

            <Box
                display={{ base: 'none', md: 'block' }}
                position="absolute"
                top="40%"
                left="10%"
                w="120px"
                h="120px"
                bg="yellow.200"
                borderRadius="60% 40% 80% 20%"
                opacity="0.7"
                zIndex="0"
                animation="pulse 4s ease-in-out infinite"
                sx={{
                    '@keyframes pulse': {
                        '0%, 100%': { transform: 'scale(1)' },
                        '50%': { transform: 'scale(1.1)' }
                    }
                }}
            />

            <Box
                display={{ base: 'none', lg: 'block' }}
                position="absolute"
                bottom="15%"
                right="12%"
                w="100px"
                h="100px"
                bg="yellow.200"
                borderRadius="50% 50% 80% 20%"
                opacity="0.6"
                zIndex="0"
                animation="float 6s ease-in-out infinite reverse"
                sx={{
                    '@keyframes float': {
                        '0%, 100%': { transform: 'translateY(0px)' },
                        '50%': { transform: 'translateY(-18px)' }
                    }
                }}
            />

            <Box
                display={{ base: 'none', md: 'block' }}
                position="absolute"
                top="25%"
                right="0"
                w="250px"
                h="4px"
                bg={accentColor}
                borderRadius="full"
                transform="rotate(45deg)"
                opacity="0.7"
                zIndex="0"
            />

            <Box
                display={{ base: 'none', lg: 'block' }}
                position="absolute"
                top="60%"
                left="0"
                w="180px"
                h="3px"
                bg="orange.400"
                borderRadius="full"
                transform="rotate(-30deg)"
                opacity="0.6"
                zIndex="0"
            />

            <Box
                display={{ base: 'none', md: 'block' }}
                position="absolute"
                top="30%"
                right="15%"
                fontSize="60px"
                color={accentColor}
                opacity="0.6"
                zIndex="0"
                transform="rotate(25deg)"
                animation="bounce 3s ease-in-out infinite"
                sx={{
                    '@keyframes bounce': {
                        '0%, 100%': { transform: 'rotate(25deg) translateY(0px)' },
                        '50%': { transform: 'rotate(25deg) translateY(-10px)' }
                    }
                }}
            >
                ↘
            </Box>

            <Box
                display={{ base: 'block', lg: 'block' }}
                position="absolute"
                bottom="35%"
                left="20%"
                fontSize="80px"
                color="orange.400"
                opacity="0.5"
                zIndex="0"
                transform="rotate(-15deg)"
                animation="bounce 4s ease-in-out infinite reverse"
                sx={{
                    '@keyframes bounce': {
                        '0%, 100%': { transform: 'rotate(-15deg) translateY(0px)' },
                        '50%': { transform: 'rotate(-15deg) translateY(-12px)' }
                    }
                }}
            >
                ↗
            </Box>

            <Box
                display={{ base: 'none', xl: 'block' }}
                position="absolute"
                top="50%"
                left="2%"
                w="60px"
                h="60px"
                bg="yellow.100"
                borderRadius="full"
                opacity="0.8"
                zIndex="0"
                animation="pulse 3s ease-in-out infinite"
                sx={{
                    '@keyframes pulse': {
                        '0%, 100%': { transform: 'scale(1)' },
                        '50%': { transform: 'scale(1.2)' }
                    }
                }}
            />

            <Box
                display={{ base: 'none', xl: 'block' }}
                position="absolute"
                top="70%"
                right="3%"
                w="80px"
                h="80px"
                bg="red.200"
                borderRadius="30% 70% 70% 30%"
                opacity="0.6"
                zIndex="0"
                animation="float 5s ease-in-out infinite"
                sx={{
                    '@keyframes float': {
                        '0%, 100%': { transform: 'translateY(0px) rotate(0deg)' },
                        '50%': { transform: 'translateY(-15px) rotate(10deg)' }
                    }
                }}
            />

            <Box
                display={{ base: 'block', md: 'none' }}
                position="absolute"
                top="10%"
                right="5%"
                w="40px"
                h="40px"
                bg={accentColor}
                borderRadius="full"
                opacity="0.6"
                zIndex="0"
                animation="pulse 3s ease-in-out infinite"
                sx={{
                    '@keyframes pulse': {
                        '0%, 100%': { transform: 'scale(1)' },
                        '50%': { transform: 'scale(1.1)' }
                    }
                }}
            />

            <Box
                display={{ base: 'block', md: 'none' }}
                position="absolute"
                bottom="20%"
                left="8%"
                w="30px"
                h="30px"
                bg="orange.300"
                borderRadius="50% 50% 0 50%"
                opacity="0.7"
                zIndex="0"
                animation="float 4s ease-in-out infinite"
                sx={{
                    '@keyframes float': {
                        '0%, 100%': { transform: 'translateY(0px)' },
                        '50%': { transform: 'translateY(-8px)' }
                    }
                }}
            />

            <Flex
                minH="100vh"
                align="center"
                justify="center"
                bg="#fafaf7"
                px={4}
            >
                <Box
                    maxW="md"
                    w="full"
                    mx="auto"
                    p={8}
                    borderWidth="1px"
                    borderRadius="lg"
                    boxShadow="xl"
                    bg="gray.50"
                    position="relative"
                    zIndex={1}
                    mt={10}
                    mb={10}
                >
                    <Flex align="center" justify="center" mb={6}>
                        <Icon as={TiPiOutline} w={8} h={8} mr={2} color="gray.800" />
                        <Heading color="black" as="h1" size="xl" fontWeight="medium" letterSpacing="tight">
                            {message.showSuccess ? 'Registration Complete' : currentStep === 1 ? 'Create Account' : 'Verify Details'}
                        </Heading>
                    </Flex>

                    {message.showSuccess ? (
                        <VStack spacing={6}>
                            <Text fontSize="sm" color="gray.600" mb={8} textAlign="center">
                                {message.text}
                            </Text>

                            <Button
                                leftIcon={<FaHome />}
                                width="full"
                                bg="black"
                                color="white"
                                _hover={{ bg: 'gray.800' }}
                                _active={{ bg: 'gray.700' }}
                                onClick={handleGoBackHome}
                                size="lg"
                                fontWeight="medium"
                                borderRadius="md"
                            >
                                Go Back Home
                            </Button>
                        </VStack>
                    ) : currentStep === 1 ? (
                        <>
                            <Text fontSize="sm" color="gray.600" mb={8} textAlign="center">
                                Set up your restaurant management account to get started.
                            </Text>

                            <form onSubmit={handleSendOtp}>
                                <VStack spacing={6}>
                                    <FormControl id="restaurantName" isRequired>
                                        <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                                            Restaurant Name
                                        </FormLabel>
                                        <Input
                                            type="text"
                                            name="restaurantName"
                                            value={formData.restaurantName}
                                            onChange={handleChange}
                                            placeholder="Your restaurant name"
                                            borderRadius="md"
                                            focusBorderColor="#9ADDFF"
                                            borderColor="gray.300"
                                            color="gray.600"
                                            _placeholder={{ color: 'gray.400' }}
                                        />
                                    </FormControl>

                                    <FormControl id="subdomain" isRequired>
                                        <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                                            Subdomain
                                        </FormLabel>
                                        <InputGroup>
                                            <Input
                                                type="text"
                                                value={subdomain}
                                                onChange={handleSubdomainChange}
                                                placeholder="your-restaurant"
                                                borderRadius="md"
                                                focusBorderColor="#9ADDFF"
                                                borderColor={
                                                    isSubdomainAvailable === true ? 'green.300' :
                                                        isSubdomainAvailable === false ? 'red.300' :
                                                            'gray.300'
                                                }
                                                color="gray.600"
                                                _placeholder={{ color: 'gray.400' }}
                                            />
                                            <InputRightElement width="5rem" display="flex" alignItems="center" gap={1}>
                                                {isCheckingSubdomain ? (
                                                    <Spinner size="sm" color="blue.500" />
                                                ) : isSubdomainAvailable === true ? (
                                                    <Icon as={FaCheck} color="green.500" />
                                                ) : isSubdomainAvailable === false ? (
                                                    <Icon as={FaTimes} color="red.500" />
                                                ) : null}
                                                <Text fontSize="xs" color="gray.500" ml={1}>
                                                    .piepos.in
                                                </Text>
                                            </InputRightElement>
                                        </InputGroup>
                                        {subdomainMessage && (
                                            <Text
                                                fontSize="xs"
                                                color={
                                                    isSubdomainAvailable === true ? 'green.500' :
                                                        isSubdomainAvailable === false ? 'red.500' :
                                                            'orange.500'
                                                }
                                                mt={1}
                                            >
                                                {subdomainMessage}
                                            </Text>
                                        )}
                                        {subdomain && isSubdomainAvailable === true && (
                                            <Text fontSize="xs" color="gray.400" mt={1}>
                                                https://admin.{sanitizeSubdomain(subdomain)}.piepos.in
                                            </Text>
                                        )}
                                        <Text fontSize="xs" color="gray.500" mt={1}>
                                            This will be your unique website address
                                        </Text>
                                    </FormControl>

                                    <FormControl id="email" isRequired>
                                        <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                                            Email Address
                                        </FormLabel>
                                        <Input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="yourmail@email.com"
                                            borderRadius="md"
                                            focusBorderColor="#9ADDFF"
                                            borderColor="gray.300"
                                            color="gray.600"
                                            _placeholder={{ color: 'gray.400' }}
                                        />
                                    </FormControl>

                                    <FormControl id="country" isRequired>
                                        <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                                            Country
                                        </FormLabel>
                                        <Select
                                            value={COUNTRIES.findIndex(c => c.code === selectedCountry?.code && c.name === selectedCountry?.name)}
                                            onChange={handleCountryChange}
                                            borderRadius="md"
                                            focusBorderColor="#9ADDFF"
                                            borderColor="gray.300"
                                            color="gray.600"
                                            size="sm"  // Changed from "md" to "sm"
                                            fontSize="sm"  // Added for smaller text
                                            height="40px"  // Reduced height
                                            sx={{
                                                // Styling for the dropdown options
                                                option: {
                                                    fontSize: 'sm',
                                                    padding: '8px 12px'
                                                }
                                            }}
                                        >
                                            {COUNTRIES.map((country, index) => (
                                                <option key={index} value={index}>
                                                    {country.flag} {country.name} ({country.code})
                                                </option>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <FormControl id="phoneNumber" isRequired>
                                        <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                                            Phone Number
                                        </FormLabel>
                                        <InputGroup>
                                            <InputLeftElement
                                                pointerEvents="none"
                                                children={
                                                    <Text fontSize="sm" color="gray.500" fontWeight="medium">
                                                        {selectedCountry?.code}
                                                    </Text>
                                                }
                                                width="4rem"
                                            />
                                            <Input
                                                type="tel"
                                                name="phoneNumber"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                placeholder={`${'0'.repeat(selectedCountry?.length || 10)}`}
                                                borderRadius="md"
                                                focusBorderColor="#9ADDFF"
                                                borderColor="gray.300"
                                                color="gray.600"
                                                _placeholder={{ color: 'gray.400' }}
                                                paddingLeft="4.5rem"
                                            />
                                        </InputGroup>
                                        <Text fontSize="xs" color="gray.500" mt={1}>
                                            {selectedCountry?.name} phone number ({selectedCountry?.length} digits)
                                        </Text>
                                    </FormControl>

                                    <FormControl id="password" isRequired>
                                        <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
                                            Password
                                        </FormLabel>
                                        <InputGroup>
                                            <Input
                                                type={showPassword ? 'text' : 'password'}
                                                name="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                placeholder="Create a password"
                                                borderRadius="md"
                                                focusBorderColor="#9ADDFF"
                                                borderColor="gray.300"
                                                color="gray.600"
                                                _placeholder={{ color: 'gray.400' }}
                                            />
                                            <InputRightElement>
                                                <Button
                                                    size="sm"
                                                    variant="link"
                                                    color="gray.500"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    _hover={{ bg: 'transparent' }}
                                                    _active={{ bg: 'transparent' }}
                                                >
                                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </Button>
                                            </InputRightElement>
                                        </InputGroup>
                                        <Text fontSize="xs" color="gray.500" mt={1}>
                                            Minimum 6 characters
                                        </Text>
                                    </FormControl>

                                    {message.text && (
                                        <Text fontSize="sm" color="red.500" mt={2}>
                                            {message.text}
                                        </Text>
                                    )}

                                    <Button
                                        type="submit"
                                        width="full"
                                        bg="black"
                                        color="white"
                                        _hover={{ bg: 'gray.800' }}
                                        _active={{ bg: 'gray.700' }}
                                        isLoading={isLoading}
                                        loadingText="Sending OTP..."
                                        size="lg"
                                        fontWeight="medium"
                                        borderRadius="md"
                                        isDisabled={isSubdomainAvailable !== true || isCheckingSubdomain}
                                    >
                                        Send Verification Code
                                    </Button>
                                </VStack>
                            </form>
                            {/* Help Links */}
                            <Box mt={6} pt={4} borderTop="1px solid" borderColor="gray.200">
                                <VStack spacing={2}>
                                    <Text fontSize="xs" color="gray.500">
                                        Already have an account?{' '}
                                        <Button
                                            as={Link}
                                            to="/login"
                                            variant="link"
                                            color="blue.500"
                                            fontWeight="bold"
                                            fontSize="xs"
                                            _hover={{ color: 'blue.600', textDecoration: 'underline' }}
                                        >
                                            Login here
                                        </Button>
                                    </Text>
                                    <Text fontSize="xs" color="gray.500">
                                        Need help?{' '}
                                        <Button
                                            as="a"
                                            href="mailto:sankalp@piepos.in?subject=Help with Registration"
                                            variant="link"
                                            color="blue.500"
                                            fontWeight="bold"
                                            fontSize="xs"
                                            _hover={{ color: 'blue.600', textDecoration: 'underline' }}
                                        >
                                            Contact us
                                        </Button>
                                    </Text>
                                </VStack>
                            </Box>
                        </>
                    ) : (
                        <>
                            <Text fontSize="sm" color="gray.600" mb={8} textAlign="center">
                                We've sent a 6-digit verification code to <strong>{formData.email}</strong>
                                {selectedCountry?.code === '+91' && (
                                    <> and <strong>{selectedCountry.code}{formData.phoneNumber}</strong></>
                                )}. Please enter it below to complete your registration.
                            </Text>

                            <form onSubmit={handleVerifyOtp}>
                                <VStack spacing={6}>
                                    <FormControl>
                                        <FormLabel fontSize="sm" fontWeight="medium" color="gray.700" textAlign="center">
                                            Enter Verification Code
                                        </FormLabel>
                                        <Flex justify="center">
                                            <PinInput
                                                value={otp}
                                                onChange={setOtp}
                                                size="lg"
                                                focusBorderColor="#9ADDFF"
                                            >
                                                <PinInputField borderColor="gray.300" color="gray.600" />
                                                <PinInputField borderColor="gray.300" color="gray.600" />
                                                <PinInputField borderColor="gray.300" color="gray.600" />
                                                <PinInputField borderColor="gray.300" color="gray.600" />
                                                <PinInputField borderColor="gray.300" color="gray.600" />
                                                <PinInputField borderColor="gray.300" color="gray.600" />
                                            </PinInput>
                                        </Flex>
                                    </FormControl>

                                    {message.text && (
                                        <Text fontSize="sm" color={message.isSuccess ? 'green.500' : 'red.500'} mt={2} textAlign="center">
                                            {message.text}
                                        </Text>
                                    )}

                                    <Button
                                        type="submit"
                                        width="full"
                                        bg="black"
                                        color="white"
                                        _hover={{ bg: 'gray.800' }}
                                        _active={{ bg: 'gray.700' }}
                                        isLoading={isLoading}
                                        loadingText="Verifying..."
                                        size="lg"
                                        fontWeight="medium"
                                        borderRadius="md"
                                        isDisabled={otp.length !== 6}
                                    >
                                        Verify & Create Account
                                    </Button>

                                    <Divider />

                                    <HStack spacing={4} width="full">
                                        <Button
                                            variant="outline"
                                            leftIcon={<FaArrowLeft />}
                                            onClick={handleBackToForm}
                                            size="sm"
                                            borderColor="gray.300"
                                            color="gray.600"
                                            _hover={{ bg: 'gray.100' }}
                                            flex={1}
                                        >
                                            Back
                                        </Button>
                                        <Button
                                            variant="link"
                                            onClick={handleResendOtp}
                                            size="sm"
                                            color="gray.600"
                                            _hover={{ color: 'gray.800' }}
                                            isLoading={isLoading}
                                            flex={1}
                                        >
                                            Resend Code
                                        </Button>
                                    </HStack>
                                </VStack>
                            </form>
                            {/* Help Links */}
                            <Box mt={6} pt={4} borderTop="1px solid" borderColor="gray.200">
                                <VStack spacing={2}>
                                    <Text fontSize="xs" color="gray.500">
                                        Already have an account?{' '}
                                        <Button
                                            as={Link}
                                            to="/login"
                                            variant="link"
                                            color="blue.500"
                                            fontWeight="bold"
                                            fontSize="xs"
                                            _hover={{ color: 'blue.600', textDecoration: 'underline' }}
                                        >
                                            Login here
                                        </Button>
                                    </Text>
                                    <Text fontSize="xs" color="gray.500">
                                        Need help?{' '}
                                        <Button
                                            as="a"
                                            href="mailto:sankalp@piepos.in?subject=Help with Registration"
                                            variant="link"
                                            color="blue.500"
                                            fontWeight="bold"
                                            fontSize="xs"
                                            _hover={{ color: 'blue.600', textDecoration: 'underline' }}
                                        >
                                            Contact us
                                        </Button>
                                    </Text>
                                </VStack>
                            </Box>
                        </>
                    )}
                </Box>
            </Flex>
        </Box>
    );
}

export default RegisterForm;